import { Navigate, useParams } from 'react-router';
import PageShell from '@components/pages/PageShell';
import {
    FocusHero,
    FocusArticles,
    FocusDocuments,
    FocusGallery,
    FocusStories,
    HighlightedProjects,
    TakeItForASpin,
    Objectives,
    StatementBlock,
} from '@components/pages/FocusSections';
import { getFocusArea } from '@/data/pages';
import { getFocusContent } from '@/data/focusContent';

/**
 * One template drives all five Focus Area pages — the designs are identical apart
 * from the hero copy, which comes from FOCUS_AREA_PAGES keyed by the URL slug,
 * and the programme's own content, which comes from FOCUS_CONTENT.
 */
export default function FocusArea() {
    const { slug } = useParams();
    const page = getFocusArea(slug);

    if (!page) return <Navigate to="/404" replace />;

    const content = getFocusContent(page.slug);
    const area = `${page.titleLead} ${page.titleBold}`.trim();

    return (
        <PageShell>
            <FocusHero
                key={page.slug}
                titleLead={page.titleLead}
                titleBold={page.titleBold}
                subtitle={page.subtitle}
                intro={page.intro}
                heroImage={page.heroImage}
            />

            {/* Objectives lead — what the programme is for, before what it runs. */}
            <Objectives objectives={content.objectives} />
            <HighlightedProjects program={page.slug} />
            <TakeItForASpin video={content.video} />

            <FocusStories area={area} content={content} />
            <FocusArticles area={area} content={content} />
            <FocusGallery area={area} content={content} />
            <FocusDocuments area={area} content={content} />

            <StatementBlock dark={page.statementDark} grey={page.statementGrey} />
        </PageShell>
    );
}
